const API = process.env.REACT_APP_API_URL;

// Django returns relative /media/... paths from endpoints serialised without a request.
export const mediaUrl = (src) => {
  if (!src) return "";
  if (/^(data:|https?:)/.test(src)) return src;
  try {
    return new URL(src, API).origin + src;
  } catch {
    return src;
  }
};
